import { Empty, Spin, Timeline, message } from "antd";
import { get, isEmpty } from "lodash";
import dayjs from "dayjs";
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import services from "services";
import { TAG_STATUS_COLOR } from "../../_redux/constants";

let isOver = false;

const ProfileIncidentPage = ({ dataSource, onChangeTotal }) => {
  const [isFetching, setIsFetching] = useState(false);
  const [logsData, setLogsData] = useState([]);
  const [logsConfig, setLogsConfig] = useState({
    size: 20,
    last_id: undefined
  });

  const getIncidentData = useCallback(async params => {
    setIsFetching(true);
    let res = await services.GdmsService.getProfileIncidents(params);

    const isSuccess = get(res, "success");
    let data = [];
    if (isSuccess) {
      data = get(res, "data", []);
      if (data.length < 20) {
        isOver = true;
      }
      setLogsData(data);
    } else {
      message.error(get(res, "message", "Có lỗi khi lấy thông tin"));
      isOver = true;
    }

    setIsFetching(false);
  }, []);

  const getIncidentTotal = useCallback(async params => {
    let res = await services.GdmsService.getProfileIncidentsTotal(params);
    const isSuccess = get(res, "success");
    if (isSuccess) {
      let data = get(res, "data") || undefined;
      if (!isEmpty(data)) {
        onChangeTotal(data);
      } else {
        onChangeTotal({ total: 0, not_complete_count: 0 });
      }
    }
  }, []);

  const renderActivity = data => {
    return data.map((item, index) => {
      let time = item?.created_date
        ? dayjs(item.created_date).format("DD/MM/YYYY HH:mm:ss")
        : "";
      let created_username = item?.created_username || "Hệ thống";
      let description = item?.description;
      let status = item?.status;

      return (
        <Timeline.Item key={index}>
          <span>{`${time} : `}</span>
          <span>{`Người báo lỗi: ${created_username}`}</span>
          <span> - </span>
          <span>{`Mô tả: ${description}`}</span>
          <span> - </span>
          <span>{`Trạng thái: ${TAG_STATUS_COLOR[status]?.label ||
            "New"}. `}</span>
          <Link
            to={`/system/admin/device-incidents?id=${item.id}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            Xem chi tiết
          </Link>
        </Timeline.Item>
      );
    });
  };

  const _handleScroll = async e => {
    if (!isOver) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        setIsFetching(true);
        let params = {
          size: logsConfig.size + 20,
          last_id: logsData?.[logsData.length - 1]?.id,
          device_id: dataSource?.device_id
        };

        let res = await services.GdmsService.getProfileIncidents(params);
        const isSuccess = get(res, "success");
        let data = [];
        if (isSuccess) {
          data = get(res, "data", []);
          if (isEmpty(data)) {
            isOver = true;
          } else {
            let joinData = JSON.parse(JSON.stringify([...logsData, ...data]));
            let last_id = joinData?.[joinData.length - 1]?.id || undefined;
            setLogsData(joinData);
            setLogsConfig(prev => {
              return {
                ...prev,
                size: prev.size + 20,
                last_id: last_id
              };
            });
          }
        } else {
          message.error(get(res, "message", "Có lỗi khi lấy thông tin"));
          isOver = true;
        }

        setIsFetching(false);
      }
    }
  };

  useEffect(
    () => {
      if (dataSource?.device_id) {
        isOver = false;
        let params = {
          size: 20,
          device_id: dataSource.device_id
        };

        getIncidentData(params);
        getIncidentTotal({
          device_id: dataSource.device_id
        });
      }
      return () => {
        setLogsData([]);
      };
    },
    [dataSource, getIncidentData, getIncidentTotal]
  );

  return (
    <Spin spinning={isFetching}>
      <div
        style={{
          height: "350px",
          overflow: "auto"
        }}
        onScroll={_handleScroll}
      >
        {isEmpty(logsData) ? (
          <Empty />
        ) : (
          <Timeline pending={isOver ? false : "Loading..."}>
            {renderActivity(logsData || [])}
          </Timeline>
        )}
      </div>
    </Spin>
  );
};

export default React.memo(ProfileIncidentPage);
